import { Loader2 } from "lucide-react";

/**
 * Google button — reused on both /login and /signup so the user always
 * sees both options in one place. Delegates to the same
 * `startGoogleLogin()` helper the landing page uses so the OAuth
 * redirect origin stays consistent.
 */
export default function GoogleButton({ label, onClick, loading = false, testId = "auth-google-btn" }) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={loading}
      data-testid={testId}
      className="w-full inline-flex items-center justify-center gap-3 border-2 border-black rounded-xl px-4 py-3 font-semibold text-slate-900 bg-white hover:bg-slate-50 disabled:opacity-60 transition"
    >
      {loading ? (
        <Loader2 className="w-5 h-5 animate-spin" />
      ) : (
        <svg viewBox="0 0 48 48" className="w-5 h-5" aria-hidden="true">
          <path fill="#EA4335" d="M24 9.5c3.9 0 6.6 1.7 8.1 3.1l6-5.8C34.5 3.3 29.7 1 24 1 14.9 1 7.2 6.3 3.6 14.1l7 5.4C12.3 13.6 17.7 9.5 24 9.5z"/>
          <path fill="#4285F4" d="M46.9 24.5c0-1.6-.1-3.2-.4-4.7H24v9h12.9c-.6 3-2.3 5.5-4.8 7.2l7.4 5.7c4.3-4 6.4-9.8 6.4-17.2z"/>
          <path fill="#FBBC05" d="M10.6 28.6c-.6-1.7-.9-3.5-.9-5.4s.3-3.7.9-5.4l-7-5.4C1.7 15.9 0 19.8 0 24s1.7 8.1 3.6 11.5l7-5.4z"/>
          <path fill="#34A853" d="M24 47c6.5 0 12-2.1 15.9-5.8l-7.4-5.7c-2 1.4-4.7 2.3-8.5 2.3-6.3 0-11.7-4.1-13.4-9.9l-7 5.4C7.2 41.7 14.9 47 24 47z"/>
        </svg>
      )}
      <span>{label}</span>
    </button>
  );
}
